// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioCircle_radio-circle__vTi9p {
  width: 2rem;
  height: 2rem;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  position: relative;
}

.RadioCircle_radio-circle__vTi9p::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  background-color: var(--primary-color);
  display: none;
}

.RadioCircle_radio-circle--checked__8S0uU::before {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/RadioCircle/RadioCircle.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".radio-circle {\n  width: 2rem;\n  height: 2rem;\n  border: 2px solid var(--primary-color);\n  border-radius: 50%;\n  position: relative;\n}\n\n.radio-circle::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 1.2rem;\n  height: 1.2rem;\n  border-radius: 50%;\n  background-color: var(--primary-color);\n  display: none;\n}\n\n.radio-circle--checked::before {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radio-circle": `RadioCircle_radio-circle__vTi9p`,
	"radio-circle--checked": `RadioCircle_radio-circle--checked__8S0uU`
};
export default ___CSS_LOADER_EXPORT___;
